
<button
rds-primary-button
size="l"
routerLink="/news/create"
>
Add news
</button>